import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import CampaignForm from "../components/marketing/CampaignForm";
import { createCampaign } from "../services/adminApi";

const CreateCampaign = () => {

    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);

    const [formData, setFormData] = useState({

    title: "",
    description: "",

    campaignType: "Banner",
    targetAudience: "All Customers",

    buttonText: "Order Now",
    backgroundColor: "#A0001C",

    redirectType: "Home",
    redirectValue: "",

    displayOrder: 1,

    status: "Running",

    startDate: "",
    endDate: "",

    banner: null,

});

   const handleChange = (e) => {

    const { name, value, files, type } = e.target;

    if (type === "file") {

        setFormData((prev) => ({
            ...prev,
            [name]: files[0],
        }));

        return;
    }

    setFormData((prev) => ({
        ...prev,
        [name]: value,
    }));

};

    const handleSubmit = async (e) => {

    e.preventDefault();

    try {

        setLoading(true);

        const data = new FormData();

        Object.keys(formData).forEach((key) => {
            data.append(key, formData[key]);
        });

        await createCampaign(data);

        navigate("/admin/marketing");

    } catch (error) {

        console.error(error);

    } finally {

        setLoading(false);

    }

};
    return (

        <div className="marketing-page">

            <h2>Create Campaign</h2>

            <CampaignForm
                formData={formData}
                handleChange={handleChange}
                handleSubmit={handleSubmit}
                loading={loading}
            />

        </div>

    );

};

export default CreateCampaign;